<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
                v-model="searchText"
                v-on:keyup.enter="searchData()"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i
            class="fa fa-search searchBtn ml-3 mt-1"
            title="ძებნა"
            @click="searchData()"
          ></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ორგანიზაციის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის ბრენდების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameAdd"
                      class="form-control"
                      placeholder="სახელი"
                      autofocus="autofocus"
                      v-model="productBrand.name"
                      v-on:input="$v.productBrand.$touch"
                      v-bind:class="{
                        'error-border': $v.productBrand.name.$error,
                        valid:
                          $v.productBrand.name.$dirty &&
                          !$v.productBrand.name.$invalid,
                      }"
                    />
                    <label for="nameAdd">სახელი</label>
                  </div>
                </div>
              </form>
              <form method="post" class="col-12 col-md-6 mt-1">
                <div class="custom-file">
                  <input
                    type="file"
                    ref="file"
                    @change="onFileSelectedV2"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    v-on:input="$v.productBrand.$touch"
                    :key="fileInputKey"
                  />
                  <label
                    class="custom-file-label"
                    for="validatedCustomFile"
                  ></label>
                </div>
                <img
                  class="img-thumbnail mt-3"
                  v-bind:src="imagePreview"
                  v-show="showPreview"
                />
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.productBrand.$dirty || $v.productBrand.$error"
              @click="$v.productBrand.$touch(), addOrEditProductBrand()"
              data-dismiss="modal"
            >
              {{ buttonName }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">სახელი</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="valueProductBrand in filteredDataArray"
            :key="valueProductBrand.nameGe"
          >
            <td data-title="სახელი" class="numeric">
              {{ valueProductBrand.name }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  @click="
                    clearData(),
                      editFillInputs(valueProductBrand),
                      modalPrepareEdit()
                  "
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  @click="getDeleteId(valueProductBrand.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteProductBrand()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";
import { baseURL, imageURL } from "../../settings/settings.js";

export default {
  data() {
    return {
      productBrand: {
        id: null,
        name: "",
        imageSrc: "",
      },
      showPreview: false,
      isEdit: false,
      imagePreview: "",
      mainImageUpuloadName: "",
      productBrandsArray: [],
      imageBaseURL: imageURL,
      buttonName: "დამატება",
      fileInputKey: 0,
      filteredDataArray: [],
      searchText: null,
    };
  },
  validations: {
    productBrand: {
      name: {
        required,
      },
      imageSrc: {
        required,
      },
    },
  },
  async created() {
    let productBrandResult = await this.$http.getProductBrand();
    this.productBrandsArray = productBrandResult.data.res;
    this.filteredDataArray = this.productBrandsArray;
  },
  methods: {
    async addOrEditProductBrand() {
      if (!this.isEdit) await this.addProductBrand();
      else await this.editProductBrand();
    },
    async addProductBrand() {
      try {
        let data = new FormData();

        data.append("name", this.productBrand.name);
        data.append("image", this.productBrand.imageSrc);
        let productBrandObjectAdd = await this.$http.postProductBrand(data);
        if (productBrandObjectAdd.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ბრენდი წარმატებით დაემატა");
          let productBrandResult = await this.$http.getProductBrand();
          this.productBrandsArray = productBrandResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ბრენდის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editProductBrand() {
      try {
        let data = new FormData();

        data.append("id", this.productBrand.id);
        data.append("name", this.productBrand.name);
        data.append("image", this.productBrand.imageSrc);

        let productBrandEditResult = await this.$http.putProductBrand(data);

        if (productBrandEditResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ბრენდი წარმატებით დარედაქტირდა");
          let productBrandResult = await this.$http.getProductBrand();
          this.productBrandsArray = productBrandResult.data.res;
          this.editImg = false;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ბრენდის დარედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteProductBrand() {
      try {
        let productPropertyDeleteResult = await this.$http.deleteProductBrand(
          this.productBrand.id
        );

        if (productPropertyDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ბრენდი წარმატებით წაიშალა");
          let productBrandResult = await this.$http.getProductBrand();
          this.productBrandsArray = productBrandResult.data.res;
        } else {
          bus.$emit("warning", "პროდუქტის ბრენდის წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      let productBrandResult = await this.$http.getByIDProductBrand(row.id);
      this.productBrand = productBrandResult.data.res;

      this.mainImageUpuloadName = this.productBrand.imageSrc;
      this.imagePreview = this.imageBaseURL + this.productBrand.imageSrc;
      this.showPreview = true;
      this.isEdit = true;
      this.buttonName = "რედაქტირება";
    },
    getDeleteId(id) {
      this.productBrand.id = id;
    },
    onFileSelectedV2() {
      this.productBrand.imageSrc = this.$refs.file.files[0];
      let reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          this.showPreview = true;
          this.imagePreview = reader.result;
        }.bind(this),
        false
      );
      if (this.productBrand.imageSrc) {
        if (/\.(jpe?g|png|gif)$/i.test(this.productBrand.imageSrc.name)) {
          reader.readAsDataURL(this.productBrand.imageSrc);
        }
      }
    },
    modalPrepareEdit() {},
    modalPrepare() {},
    searchData() {
      this.filteredDataArray = this.productBrandsArray.filter(
        (item) =>
          item.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
      );
    },
    clearData() {
      this.productBrand.id = null;
      this.productBrand.name = "";
      this.productBrand.imageSrc = "";
      this.mainImageUpuloadName = "";

      this.showPreview = false;
      this.imagePreview = "";
      this.isEdit = false;
      this.buttonName = "დამატება";

      this.fileInputKey++;

      this.$v.$reset();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";
</style>



// WEBPACK FOOTER //
// src/components/view/ProductBrand.vue